import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AssessmentQuestionControlService} from './assessment-question-control.service';
import { AssessmentQuestionBase } from './models/assessment-question-base.model';
import { AssessmentFormService } from './assessment-form.service';
import { FormService } from '../form/form.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { SearchAndSelect } from '../form/models/serachselect.model';

@Component({
    selector: 'app-assessment-form',
    templateUrl: './assessment-form.component.html',
    providers: [AssessmentQuestionControlService, AssessmentFormService],
    standalone: false
})
export class AssessmentFormComponent implements OnInit {
  @Input() questions: AssessmentQuestionBase<string>[] | null = [];
  @Input() assessment_template_id : any;
  form: FormGroup;
  formatValue: any;
  keyValue: any;
  vitalDefinationList: any;
  assessmentQues: any;
  assessment_data: any;
  @Input() fieldGroup: any = [];
  payLoad = '';
  private _subscribeOption: any;

  constructor(
    private baseService: BaseService,
    private qcs: AssessmentQuestionControlService,
    private formService: FormService,) {}

  ngOnInit() {
    console.log("Uiiiii Engine field group ", this.fieldGroup);
    this.form = this.qcs.toFormGroup(this.questions as AssessmentQuestionBase<string>[]);
    // this.formatValue = this.form.controls.tt3['question_component'].question.calculation_formula;
    console.log("assessment_template_id",this.assessment_template_id);
    if(this.assessment_template_id){
      let args = {
        "args": "id:"+this.assessment_template_id
      }
      this.baseService.getData(args, "",'system_template', 'form-template-engine',"GET_SELECTED_VITAL_DATA").subscribe(res => {
        if (res.errCode != undefined && res.errCode == 0 && res.resource.length > 0) {
          console.log("Record Found:::::",res.resource);
          this.vitalDefinationList = res.resource
        }
        else {
          console.log("No such record found " + res.message);
        }
      });
    }
  } 
  onValueChanged(e: any) {
    console.log("onValueChanged", e);
    let result;
    for (let key in this.form.value) {
      if(this.form.controls[key]['question_component'].question.calculated_field){
        // this.formatValue = this.form.controls[key]['question_component'].question.calculation_formula;
        this.keyValue = this.form.controls[key]['question_component'].question.key
        let vital_id = this.form.controls[key]['question_component'].question.select_defination;
        if(this.vitalDefinationList.filter(data => data.id == vital_id)){
          let data = this.vitalDefinationList.filter(data => data.id == vital_id);
          console.log("data:::",data[0].vitalType + "----vital Formula::::: " + data[0].vitalFormula);
          this.formatValue = data[0].vitalFormula;
          var decimalV = data[0].decimalV;
        }
        for (let key in this.form.value) {
            var removeStr = `\\b${key}\\b`;
            const regex =  new RegExp(removeStr,'g'); // correct way
            this.formatValue = this.formatValue.replace(regex, this.form.value[key]); // it works
          // this.formatValue  = this.formatValue.replaceAll(key, this.form.value[key]);
        }
        try{
          console.log("formatValue::::!!!",this.formatValue);
          result = eval(this.formatValue);
          
          if (decimalV && result != undefined && (result.toString().indexOf(".") > -1)) {
            result = (parseFloat(result).toFixed(decimalV)).toString();
          }
          console.log("key::::!!!",this.keyValue + "result::::!!!",result);
          if(result!=undefined)
            this.form.controls[this.keyValue].setValue(result);
        }catch(error){
          console.log("wrong input",this.keyValue);
        }
      }
    }
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.getRawValue());
  }
}